/* eslint-disable react/prop-types */
import { Form } from 'react-bootstrap';

const formatNumber = (num) => {
    const cleanNum = String(num).replace(/\D/g, '');

    if (!cleanNum) return '';

    return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const NumberInput = ({value, onChange, label, placeholder, required = false, disabled = false, className = "", ...props }) => {
  const handleChange = (e) => {
     const rawValue = e.target.value.replace(/\D/g, '');
    onChange(rawValue);
  };

  return (
    <Form.Group className={className}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        type="text"
        value={formatNumber(value || '')}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        dir="ltr"
        {...props}
      />
    </Form.Group>
  );
};

export default NumberInput;
